import React from 'react';
import classNames from 'classnames';
import User from 'records/User';
import BarScore from './BarScore';
import UserAvatar from 'components/pure/utils/UserAvatar';
import 'styles/scorecards/ScorecardResultsUserScoreColumnHeader.styl';

/**
 * <ScorecardResultsUserScoreColumnHeader /> renders the header for a `Scorecard.results` object
 * which includes the user's avatar image above the score label
 */
export default class ScorecardResultsUserScoreColumnHeader extends React.Component {
  constructor() {
    super();
    this.state = {isEditOverlayShown: false};
  }

  showEditOverlay = () => {
    this.setState({isEditOverlayShown: true});
  };

  hideEditOverlay = () => {
    this.setState({isEditOverlayShown: false});
  };

  render() {
    const result = this.props.result;
    const user =
      result.reviewerUser ||
      new User({
        id: result.reviewerUserId,
        avatar: result.userAvatar,
        first_name: result.firstName,
        last_name: result.lastName,
        display_name: result.displayName,
        color: result.color,
      });

    const showEditOverlay = this.state.isEditOverlayShown && this.props.showEditOverlay;
    const avatarClassName = classNames('scorecard-avatar-container', {
      'edit-avatar': showEditOverlay,
    });
    return (
      <div className="user-score-column-header">
        <div
          className={avatarClassName}
          onMouseOver={this.showEditOverlay}
          onMouseLeave={this.hideEditOverlay}
          onClick={this.props.showEditOverlay ? () => this.props.goToEditScreen(result) : null}>
          <UserAvatar user={user} enableTooltip={true} tooltipDirection="top" />
          {showEditOverlay && (
            <div className="scorecard-edit-overlay">
              <div className="text">Edit</div>
            </div>
          )}
        </div>
        <BarScore result={result} />
      </div>
    );
  }
}
